import { FC } from 'react';
import List from 'components/segments/components/List';

const Screen: FC = () => {
  return (
    <List
      entityName="client-segments"
      entityEndpoint="client-segments"
      displayName="client-segment"
    />
  );
};

export default Screen;
